import { Layout } from "@/shared/ui/Layout/Layout";
import { LayoutHeader } from "@/widgets/LayoutHeader";
import { LayoutSidebar } from "@/widgets/LayoutSidebar";
import { ProfileSidebar } from "@/widgets/ProfileSidebar/ui/ProfileSidebar";
import { WorkspaceHeader } from "@/widgets/WorkspaceHeader/ui/WorkspaceHeader";
import { ReactNode } from "react";

export const baseLayout = (children: ReactNode, hasUserIdParam: boolean) => {
  return (
    <Layout
      headerSlot={<><LayoutHeader />{hasUserIdParam ? <WorkspaceHeader /> : undefined}</>}
      sidebarSlot={
        <>
          <LayoutSidebar />
          <ProfileSidebar />
        </>
      }
    >
      {children}
    </Layout>
  );
};
